import { useTranslation } from 'react-i18next';
import { useMutation, UseMutationResult, UseMutationOptions } from 'react-query';

import { useDispatch } from '../../Hooks';
import { notificationSlice } from '../../ReduxStore/Notification/NotificationSlice';

import { applicationSupportUndeleteApplication } from '../../Services/UndeleteApplicationService';

type UndeleteApplicationParams = { applicationId: string };
type UndeleteApplicationResponse = { success: boolean };

export function useUndeleteApplicationMutation(
  options?: UseMutationOptions<UndeleteApplicationResponse, unknown, UndeleteApplicationParams, unknown>,
): UseMutationResult<UndeleteApplicationResponse, unknown, UndeleteApplicationParams, unknown> {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return useMutation<UndeleteApplicationResponse, unknown, UndeleteApplicationParams, unknown>(
    applicationSupportUndeleteApplication,
    {
      ...options,

      onError: async (error, variables, context) => {
        dispatch(
          notificationSlice.actions.setError({
            message: t('notifications.undeleteApplicationFailure'),
          }),
        );

        if (options?.onError) {
          await options.onError(error, variables, context);
        }
      },
    },
  );
}
